import Product from 'models/Product';

import Component from './component';

export interface Props extends ParentProps { }

export interface ParentProps {
    product: Product;
    content: {
        titles: {
            duration: string;
            durationValue: string;
            recommendation: string;
            quantity: string;
            target: string;
        };
    };
}

Component.defaultProps = {};
export default Component;
